import { Injectable } from '@angular/core';
import { IKeyValue } from 'src/app/models/ikeyvalue.interface';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  getUniqueKeyValueArray(arr: IKeyValue[]): any[] {
    const uniqueValues: IKeyValue[] = [];

    arr.forEach(element => {
      const res = uniqueValues.find(o => o.id === element.id);
      if (!res) {
        uniqueValues.push(element);
      }
    });

    return uniqueValues;
  }

  getSpecificFieldsFromArrayWithName(items: any[], fields: string[], names: string[]): any[] {
    const res: any[] = [];

    items.forEach(el => {
      const new_res = {};
      for (let idx = 0; idx < fields.length; idx++) {
        const field = fields[idx];
        const name = names[idx];
        new_res[name] = el[field];
      }
      res.push(new_res);
    });
    return res;
  }


  prepareArrayForTableWithNames(items: any[], fields: string[], names: string[]) {
    // Removing unnecessary fields
    var arr = [...items];
    if (fields.length == 0) {
      fields = Object.keys(arr[0]);
    }
    if (names.length == 0) {
      names = [...fields];
    }
    arr = this.getSpecificFieldsFromArrayWithName(items, fields, names);
    // Converting datetime to normal string
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < names.length; j++) {
        const el = arr[i][names[j]];
        if (this.isDate(el)) {
          const d = this.formatDateTime(el);
          arr[i][names[j]] = d;
        }
      }
    }
    return arr;
  }

  isDate(value: any) {
    if (Object.prototype.toString.call(value) === "[object Date]")
      return true;
    return false;
  }

  formatDateTime(date) {
    var d = new Date(date),
      hour = '' + d.getHours(),
      minute = '' + d.getMinutes(),
      seconds = '' + d.getSeconds()

    if (hour.length < 2) hour = '0' + hour;
    if (minute.length < 2) minute = '0' + minute;
    if (seconds.length < 2) seconds = '0' + seconds;

    const day = this.formatDate(date);
    const time = [hour, minute, seconds].join(':');

    return `${day} ${time}`;
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }


  getUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  getDateFromString(str: string): Date {
    const year = +str.substr(6, 4);
    const month = +str.substr(3, 2) - 1;
    const day = +str.substr(0, 2);
    const date = new Date(year, month, day);
    return date;
  }

  getStringFromDate(d: Date): string {
    const month = (d.getMonth() + 1).toString();
    const day = d.getDate().toString();
    return `${+day < 10 ? '0' + day : day }-${+month < 10 ? '0' + month : month}-${d.getFullYear()}`;
  }

  replaceDateStringToIsoFormat(str: string) {
    return str.replace( /(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3');
  }

  getBytesToSize(bytes): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) { return 'n/a'; }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
    if (i === 0) { return `${bytes} ${sizes[i]}`; }
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
  }

  validateEmail(email: string): boolean {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
}
